import { render, staticRenderFns } from "./Fundadores.vue?vue&type=template&id=c00a45f4&scoped=true&lang=pug"
import script from "./Fundadores.vue?vue&type=script&lang=js"
export * from "./Fundadores.vue?vue&type=script&lang=js"
import style0 from "./Fundadores.styl?vue&type=style&index=0&id=c00a45f4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a45f4",
  null
  
)

export default component.exports